import { useEffect, useState } from "react";
import i18n from "../../../lib/i18n";
import AddPagesUi from "../../../ui/pages/addPages";
import { GetPagesData, GetPageSectionByIdData, GetPagesSectionData } from "../../../lib/data";
import AddPagesSectionUi from "../../../ui/pageSectionUi/addPageSection";
import EditPagesSectionUi from "../../../ui/pageSectionUi/editPageSection";
import { useParams } from "react-router-dom";

export default function EditPagesSection() {

    const {pageSectionId} = useParams();
    const [pagesData, setPagesData] = useState([]);
    const [pagesSectionData, setPagesSectionData] = useState({});
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleFilterApi();
    }, [])

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const pageSectionData = await GetPageSectionByIdData(pageSectionId);
        setPagesSectionData({});
        setPagesSectionData(pageSectionData.data);
    };

    const handleFilterApi = async () => {
        const pageData = await GetPagesData();
        setPagesData([]);
        pageData.data.map((e) => setPagesData((prev) => [...prev, e]));
    };

    const search = async (param) => {
        const params = [ {"name": param} ];
        if(param){
            const pageDataFilter = await GetPagesData(1,params);
            setPagesData([]);
            pageDataFilter.data.map((e) => setPagesData((prev) => [...prev, e]));
        }
    };

    return (
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("add_page_title.page")} </h1>
                <EditPagesSectionUi search={search} pagesData={pagesData} data={pagesSectionData} />
            </div>
        </div>
    );
};